import { render, staticRenderFns } from "./EstadoHistoricoSimpleTable.vue?vue&type=template&id=2b35a644&scoped=true"
import script from "./EstadoHistoricoSimpleTable.vue?vue&type=script&lang=js"
export * from "./EstadoHistoricoSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35a644",
  null
  
)

export default component.exports